import React, { useEffect } from 'react'
import { NurseFormSchema, updateNurseFormSchema } from '../../schemas/NurseFormSchema'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { InputLabel } from '@mui/material';
import InputController from '../../components/InputController/InputController';
import { FormContainer } from "../Hospitals/HospitalStyle"
import { useNavigate } from 'react-router-dom';
import { useUpdateForm } from '../../context/UpdateFormProvider';
import SelectController from '../../components/SelectController/SelectController';
import { facilityTypeOptions, genderOptions, regions } from './formOptions';
import DatePickerController from '../../components/CustomDatepicker/CustomDatePicker';

const ViewNurse = () => {
  const navigate = useNavigate()
  const { updateFormValues } = useUpdateForm()

  let {
    nurses_first_name = "",
    nurses_last_name = "",
    nurses_national_id = "",
    nurses_sex = "",
    nurses_dob = "",
    facility_name = "",
    facility_type = "",
    city = "",
    nurses_role = "",
    nurses_email_id = "",
    password = "",
    nurses_contact = "",
    nurses_region = "",
    section = "",
  } = updateFormValues || {};
  const isUpdate = !!Object.keys(updateFormValues || {}).length

  const { control, formState: { errors } } = useForm({
    resolver: yupResolver(isUpdate ? updateNurseFormSchema : NurseFormSchema),
    mode: "onChange",
    defaultValues: {
      nurses_first_name: isUpdate ? nurses_first_name : "",
      nurses_last_name: isUpdate ? nurses_last_name : "",
      nurses_national_id: isUpdate ? nurses_national_id : "",
      nurses_sex: isUpdate ? nurses_sex : "",
      nurses_dob: isUpdate ? nurses_dob : "",
      facility_name: isUpdate ? facility_name : "",
      facility_type: isUpdate ? facility_type : "",
      city: isUpdate ? city : "",
      nurses_role: isUpdate ? nurses_role : "",
      nurses_email_id: isUpdate ? nurses_email_id : "",
      password: isUpdate ? "**********" : "",
      confirmPassword: isUpdate ? "**********" : "",
      nurses_contact: isUpdate ? nurses_contact : "",
      nurses_region: isUpdate ? nurses_region : "",
      section: isUpdate ? section : "",
    }
  });

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };

    const handleLoad = () => {
      const navigationEntry = window.performance.getEntriesByType("navigation")[0];
      if (navigationEntry && navigationEntry.type === 'reload') {
        navigate('/hospital-list');
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('load', handleLoad);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  return (
    <form>
      <InputLabel sx={{ fontSize: "1.5rem" }}>Add Nurse</InputLabel>
      <FormContainer>
        <InputController
          name="nurses_first_name"
          label="First Name"
          control={control}
          isLoading={true}
          errors={errors} />

        <InputController
          name="nurses_last_name"
          label="Last Name"
          control={control}
          isLoading={true}
          errors={errors} />

        <InputController
          name="nurses_national_id"
          label="National ID"
          isNumberField={true}
          control={control}
          isLoading={true}
          errors={errors} />

        <SelectController
          name="nurses_sex"
          label="Gender"
          control={control}
          options={genderOptions}
          isLoading={true}
          errors={errors}
        />

        {/* <InputController
          name="nurses_dob"
          label="Date of Birth"
          control={control}
          isLoading={true}
          errors={errors} /> */}

        <DatePickerController
          name="nurses_dob"
          label="Date of Birth"
          control={control}
          isLoading={true}
          errors={errors}
          readOnly={isUpdate ? true : false}
        />

        <InputController
          name="facility_name"
          label="Facility Name"
          control={control}
          isLoading={true}
          errors={errors} />

        <SelectController
          name="facility_type"
          label="Facility Type"
          control={control}
          options={facilityTypeOptions}
          isLoading={true}
          errors={errors}
        />

        <InputController
          name="city"
          label="City"
          control={control}
          isLoading={true}
          errors={errors} />

        <InputController
          name="nurses_role"
          label="Nurse Role"
          control={control}
          isLoading={true}
          errors={errors} />

        <InputController
          name="nurses_email_id"
          label="Email ID"
          control={control}
          isLoading={true}
          errors={errors} />

        <InputController
          name="section"
          label="Section"
          control={control}
          isLoading={true}
          errors={errors} />

        <InputController
          name="nurses_contact"
          label="Contact Number"
          isNumberField={true}
          control={control}
          isLoading={true}
          errors={errors} />


        <InputController
          name="password"
          label="Password"
          control={control}
          isLoading={true}
          errors={errors}
        />
        <InputController
          name="confirmPassword"
          label="Confirm Password"
          control={control}
          isLoading={true}
          errors={errors}
          isGrow
          isCustomError
        />

        <SelectController
          name="nurses_region"
          label="Region"
          control={control}
          options={regions}
          isLoading={true}
          errors={errors}
        />
      </FormContainer>
    </form>
  )
}

export default ViewNurse